import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderKoDataTable, renderKoEmptyState, renderKoInputCell } from '~/components/templates/listPageDataTable';
import { renderEditToggle } from '~/components/templates/editToggle';
import { html, LpButton, LpEditCard, LpEditGrid, LpEditPage, LpEditSectionTitle, LpFormField, LpIcon, LpPageHeader, LpTable, raw } from '~/design-system';
export class adminRecruitingQuestionEdit_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminRecruitingQuestionEdit-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            id: ko.observable(null),
            active: ko.observable(true),
            deletable: ko.observable(true),
            pageTitle: ko.observable('Recruiting Question'),
            newTitle: ko.observable('New Recruiting Question'),
            editTitle: ko.observable('Edit Recruiting Question'),
            backLabel: ko.observable('Back to Available Questions'),
            showDelete: ko.observable(true),
            showQuestionCode: ko.observable(false),
            showDisplayOrder: ko.observable(false),
            uiQuestionId: ko.observable(''),
            questionCode: ko.observable(''),
            displayOrder: ko.observable(''),
            label: ko.observable(''),
            required: ko.observable(false),
            inputTypeId: ko.observable(''),
            maxSize: ko.observable(''),
            defaultOption: ko.observable(''),
            inputTypes: ko.observableArray([]),
            answers: ko.observableArray([]),
            showAnswers: ko.pureComputed(function () { return self.isAnswerBasedInputType(); }),
            onClickBack: function () { self.caller.backToQuestions(); },
            onClickSave: function () { self.caller.saveQuestion(); },
            onClickDelete: function () { self.caller.deleteQuestion(); },
            onClickAddAnswer: function () { self.addAnswer(); },
            onClickRemoveAnswer: function (answer) { self.removeAnswer(answer); },
            onAnswerDragDrop: function (dragged, target) { self.reorderAnswer(dragged, target); },
            onAnswerActiveChange: function (answer) { self.onAnswerActiveChange(answer); },
            onAnswerDefaultChange: function (answer) { self.onAnswerDefaultChange(answer); },
        };
    }
    /**
     * Initialize nested form selects.
     *
     * @return void
     */
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.inputTypeSelect = new listPageSelect_template('adminRecruitingQuestionInputTypeSelect', vm, this.caller);
        this.inputTypeSelect.setLabel('Question Type');
        this.inputTypeSelect.setFormField(true);
        this.inputTypeSelect.setOptions([]);
        this.inputTypeSelect.bindValue(vm.inputTypeId);
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: html `<span data-bind="text: id() ? editTitle() : newTitle()"></span>`,
            description: 'Define how this question is presented and answered in the recruiting flow.',
            icon: 'question',
            actions: html `
                    ${LpButton({
                label: html `<span data-bind="text: backLabel"></span>`,
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                            ${LpButton({
                label: 'Delete',
                prefixIcon: 'trash',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'visible: showDelete() && id() && deletable(), click: onClickDelete',
                },
            })}
                    ${LpButton({
                label: 'Save',
                prefixIcon: 'check',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickSave',
                },
            })}

                `,
        })}

            ${LpEditPage({
            className: 'edit-page--recruiting-question',
            children: html `
                    ${LpEditCard({
                title: 'Question',
                description: 'Define the question text, behavior, and answer type.',
                className: 'recruiting-question-form-card',
                bodyClassName: 'recruiting-question-form',
                children: html `
                            <section class="recruiting-question-form__section">
                                ${LpFormField({
                    label: 'Display Text',
                    required: true,
                    className: 'form-group',
                    children: raw('<input class="edit-input" type="text" data-bind="value: label" />'),
                })}
                            </section>

                            <section class="recruiting-question-form__section">
                                ${LpEditGrid({
                    className: 'recruiting-question-form__grid',
                    children: html `
                                        ${LpEditSectionTitle({ title: 'Properties', className: 'recruiting-question-form__section-header' })}
                                        ${LpFormField({
                        label: 'Question ID',
                        className: 'form-group',
                        children: raw('<input class="edit-input" type="text" data-bind="value: uiQuestionId" />'),
                    })}
                                        ${LpFormField({
                        label: 'Question Type',
                        required: true,
                        className: 'form-group',
                        children: raw(this.inputTypeSelect.getHtmlBuild()),
                    })}
                                        ${LpFormField({
                        label: 'Question Code',
                        className: 'form-group',
                        attributes: {
                            'data-bind': 'visible: showQuestionCode',
                        },
                        children: raw('<input class="edit-input" type="text" data-bind="value: questionCode" />'),
                    })}
                                        ${LpFormField({
                        label: 'Display Order',
                        className: 'form-group',
                        attributes: {
                            'data-bind': 'visible: showDisplayOrder',
                        },
                        children: raw('<input class="edit-input" type="number" data-bind="value: displayOrder" />'),
                    })}
                                        ${LpFormField({
                        label: 'Max Size',
                        className: 'form-group',
                        attributes: {
                            'data-bind': 'visible: Number(inputTypeId()) === 4',
                        },
                        children: raw('<input class="edit-input" type="number" data-bind="value: maxSize" />'),
                    })}
                                        ${LpFormField({
                        label: 'Default Value',
                        className: 'form-group recruiting-question-form__full',
                        attributes: {
                            'data-bind': 'visible: Number(inputTypeId()) === 1',
                        },
                        children: raw('<input class="edit-input" type="text" data-bind="value: defaultOption" />'),
                    })}
                                    `,
                })}
                            </section>

                            <section class="recruiting-question-form__section">
                                ${LpEditSectionTitle({ title: 'Options', className: 'recruiting-question-form__section-header' })}
                                <div class="edit-toggles recruiting-question-form__options">
                                    ${raw(renderEditToggle({
                    selectedBinding: 'active',
                    inputHtml: '<input type="checkbox" data-bind="checked: active" />',
                    labelHtml: '<span>Active</span>',
                }))}
                                    ${raw(renderEditToggle({
                    selectedBinding: 'required',
                    inputHtml: '<input type="checkbox" data-bind="checked: required" />',
                    labelHtml: '<span>Required</span>',
                }))}
                                    <!-- ko if: showDelete -->
                                    ${raw(renderEditToggle({
                    selectedBinding: 'deletable',
                    inputHtml: '<input type="checkbox" data-bind="checked: deletable, enable: showDelete" />',
                    labelHtml: '<span>Deletable</span>',
                }))}
                                    <!-- /ko -->
                                </div>
                            </section>
                        `,
            })}

                    ${LpEditCard({
                title: 'Answers',
                description: 'Configure the answer options shown for this question.',
                className: 'recruiting-question-answers-card',
                actions: LpButton({
                    label: 'Add Answer',
                    prefixIcon: 'plus',
                    size: 'sm',
                    variant: 'secondary',
                    attributes: {
                        'data-bind': 'click: onClickAddAnswer',
                    },
                }),
                attributes: {
                    'data-bind': 'visible: showAnswers',
                },
                children: raw(this.getAnswersTableHtml()),
            })}
                `,
        })}
        `;
    }
    getAnswersTableHtml() {
        const columns = this.getAnswerTableColumns();
        return renderKoDataTable({
            title: 'Answers',
            caption: 'Recruiting question answer options',
            columns,
            className: 'recruiting-question-answers-table recruiting-question-answers-table--compact',
            children: this.getAnswersTableBodyHtml(columns),
        });
    }
    getAnswerTableColumns() {
        return [
            {
                key: 'drag',
                label: '',
                align: 'center',
                width: 56,
                minWidth: 48,
                required: true,
            },
            {
                key: 'active',
                label: 'Active',
                align: 'center',
                resizable: true,
                width: 96,
                minWidth: 88,
            },
            {
                key: 'answerDisplay',
                label: 'Display Text',
                resizable: true,
                minWidth: 220,
            },
            {
                key: 'value',
                label: 'Value',
                resizable: true,
                minWidth: 180,
            },
            {
                key: 'defaultAnswer',
                label: 'Default',
                align: 'center',
                resizable: true,
                width: 104,
                minWidth: 88,
            },
            {
                key: 'actions',
                label: 'Actions',
                align: 'center',
                width: 96,
                minWidth: 88,
                required: true,
            },
        ];
    }
    getAnswersTableBodyHtml(columns) {
        return html `
            ${LpTable.Body({
            attributes: {
                'data-bind': 'foreach: answers',
            },
            children: LpTable.Row({
                className: 'question-bank-page-row',
                attributes: {
                    'data-bind': "dropZone: { accepts: 'question-answers', drop: function (dragged) { $parent.onAnswerDragDrop(dragged, $data); } }",
                },
                children: html `
                        ${LpTable.Cell({
                    column: columns[0],
                    className: 'question-bank-page-table__drag',
                    children: html `
                                <span class="question-bank-drag-handle" role="button" tabindex="0" aria-label="Drag to reorder" data-bind="dragZone: { name: 'question-answers', data: $data }">
                                    ${LpIcon({ name: 'dots-six-vertical', size: 18, className: 'question-bank-drag-handle__icon' })}
                                </span>
                            `,
                })}
                        ${LpTable.Cell({
                    column: columns[1],
                    className: 'recruiting-question-answers-table__active',
                    children: html `<input class="table-checkbox" type="checkbox" data-bind="checked: active, event: { change: $parent.onAnswerActiveChange }" />`,
                })}
                        ${this.getAnswerInputCell(columns[2], 'answerDisplay')}
                        ${this.getAnswerInputCell(columns[3], 'value')}
                        ${LpTable.Cell({
                    column: columns[4],
                    className: 'recruiting-question-answers-table__default',
                    children: html `<input class="table-checkbox" type="checkbox" data-bind="checked: defaultAnswer, event: { change: $parent.onAnswerDefaultChange }" />`,
                })}
                        ${LpTable.Cell({
                    column: columns[5],
                    className: 'recruiting-question-answers-table__actions',
                    children: html `
                                <div class="recruiting-question-answers-table__actions-inner">
                                    ${LpButton({
                        ariaLabel: 'Remove answer',
                        prefixIcon: 'trash',
                        size: 'sm',
                        shape: 'square',
                        variant: 'ghost',
                        className: 'question-bank-icon-danger',
                        attributes: {
                            'data-bind': 'click: $parent.onClickRemoveAnswer',
                        },
                    })}
                                </div>
                            `,
                })}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: 'answers().length === 0',
            title: 'No answers configured',
            description: 'Add an answer option for this question.',
            icon: 'list-checks',
        })}
        `;
    }
    getAnswerInputCell(column, binding) {
        return renderKoInputCell({
            column,
            binding,
        });
    }
    /**
     * Configure the shared editor for a specific question family.
     *
     * @param options any
     * @return void
     */
    setEditorOptions(options) {
        const vm = this.getTemplateViewModel();
        vm.pageTitle(options.pageTitle || 'Recruiting Question');
        vm.newTitle(options.newTitle || 'New Recruiting Question');
        vm.editTitle(options.editTitle || 'Edit Recruiting Question');
        vm.backLabel(options.backLabel || 'Back to Available Questions');
        vm.showDelete(typeof options.showDelete !== 'undefined' ? !!options.showDelete : true);
        vm.showQuestionCode(!!options.showQuestionCode);
        vm.showDisplayOrder(!!options.showDisplayOrder);
        if (!vm.showDelete()) {
            vm.deletable(false);
        }
    }
    /**
     * Apply reference data returned by the API to the view model.
     *
     * @param references any
     * @return void
     */
    setReferences(references) {
        const vm = this.getTemplateViewModel();
        const inputTypes = references && Array.isArray(references.inputTypes) ? references.inputTypes : [];
        const normalized = inputTypes.map((inputType) => ({
            id: String(inputType.id),
            inputType: inputType.inputType || inputType.name || '',
        }));
        vm.inputTypes(normalized);
        this.inputTypeSelect.setOptions(normalized.map((inputType) => ({ id: inputType.id, name: inputType.inputType })));
    }
    /**
     * Apply a recruiting question DTO to the edit view model.
     *
     * @param question any
     * @return void
     */
    setQuestion(question) {
        const vm = this.getTemplateViewModel();
        const configuration = question && question.configuration ? question.configuration : {};
        const inputType = configuration.inputType || {};
        vm.id(question && question.id ? Number(question.id) : null);
        vm.active(question && typeof question.active !== 'undefined' ? !!question.active : true);
        vm.deletable(question && typeof question.deletable !== 'undefined' ? !!question.deletable : true);
        if (!vm.showDelete()) {
            vm.deletable(false);
        }
        vm.uiQuestionId(question && (question.uiQuestionId || question.uiQuestionID) ? (question.uiQuestionId || question.uiQuestionID) : '');
        vm.questionCode(question && (question.questionCode || question.code) ? (question.questionCode || question.code) : '');
        vm.displayOrder(question && typeof question.displayOrder !== 'undefined' && question.displayOrder !== null ? question.displayOrder : '');
        vm.label(configuration.label || '');
        vm.required(!!configuration.required);
        vm.inputTypeId(configuration.inputId ? String(configuration.inputId) : (inputType.id ? String(inputType.id) : ''));
        vm.maxSize(configuration.maxSize || configuration.maxsize || '');
        vm.defaultOption(configuration.defaultOption || '');
        vm.answers(this.normalizeAnswerOrder((question && question.answers ? question.answers : []).map((answer, index) => this.mapAnswer(answer, index))));
    }
    /**
     * Build the save payload from the current view model state.
     *
     * @return any
     */
    getPayload() {
        const vm = this.getTemplateViewModel();
        return {
            id: vm.id(),
            active: vm.active(),
            deletable: vm.deletable(),
            uiQuestionId: vm.uiQuestionId(),
            questionCode: vm.questionCode(),
            displayOrder: vm.displayOrder() !== '' ? Number(vm.displayOrder()) : null,
            configuration: {
                label: vm.label(),
                required: vm.required(),
                inputId: vm.inputTypeId() ? Number(vm.inputTypeId()) : null,
                inputType: {
                    id: vm.inputTypeId() ? Number(vm.inputTypeId()) : null,
                },
                maxSize: vm.maxSize(),
                defaultOption: vm.defaultOption(),
            },
            answers: this.normalizeAnswerOrder(vm.answers() || []).map((answer, index) => ({
                id: answer.id || null,
                answerDisplay: answer.answerDisplay(),
                value: answer.value(),
                displayOrder: answer.displayOrder() !== '' ? Number(answer.displayOrder()) : index,
                active: answer.active(),
                defaultAnswer: answer.defaultAnswer(),
            })),
        };
    }
    /**
     * Handle add answer.
     *
     * @return void
     */
    addAnswer() {
        const answers = this.getTemplateViewModel().answers;
        answers.push(this.mapAnswer({
            active: true,
            displayOrder: answers().length,
        }, answers().length));
        answers(this.normalizeAnswerOrder(answers() || []));
    }
    /**
     * Handle remove answer.
     *
     * @param answer any
     * @return void
     */
    removeAnswer(answer) {
        const answers = this.getTemplateViewModel().answers;
        answers.remove(answer);
        answers(this.normalizeAnswerOrder(answers() || []));
    }
    /**
     * Reorder answers after drag/drop.
     *
     * @param dragged any
     * @param target any
     * @return void
     */
    reorderAnswer(dragged, target) {
        if (!dragged || !target || dragged === target) {
            return;
        }
        const answers = this.getTemplateViewModel().answers;
        const rows = answers() || [];
        const fromIndex = rows.indexOf(dragged);
        const toIndex = rows.indexOf(target);
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) {
            return;
        }
        rows.splice(fromIndex, 1);
        rows.splice(toIndex, 0, dragged);
        answers(this.normalizeAnswerOrder(rows));
    }
    /**
     * Keep inactive answers from remaining selected as defaults.
     *
     * @param answer any
     * @return void
     */
    onAnswerActiveChange(answer) {
        if (answer && typeof answer.active === 'function' && !answer.active() && typeof answer.defaultAnswer === 'function') {
            answer.defaultAnswer(false);
        }
    }
    /**
     * Enforce default-answer rules for the selected question type.
     *
     * @param answer any
     * @return void
     */
    onAnswerDefaultChange(answer) {
        if (!answer || typeof answer.defaultAnswer !== 'function') {
            return;
        }
        if (answer.defaultAnswer() && typeof answer.active === 'function' && !answer.active()) {
            answer.active(true);
        }
        if (!answer.defaultAnswer() || this.inputTypeAllowsMultipleDefaults(this.getSelectedInputTypeName())) {
            return;
        }
        (this.getTemplateViewModel().answers() || []).forEach((row) => {
            if (row !== answer && typeof row.defaultAnswer === 'function') {
                row.defaultAnswer(false);
            }
        });
    }
    /**
     * Return the current input type name.
     *
     * @return string
     */
    getSelectedInputTypeName() {
        const vm = this.getTemplateViewModel();
        const inputTypeId = String(vm.inputTypeId() || '');
        const match = (vm.inputTypes() || []).filter((inputType) => String(inputType.id) === inputTypeId)[0];
        if (match && match.inputType) {
            return String(match.inputType).toLowerCase();
        }
        return inputTypeId === '3' ? 'checkbox' : (inputTypeId === '1' ? 'select' : (inputTypeId === '2' ? 'radio' : ''));
    }
    /**
     * Return whether the current question type uses configured answer options.
     *
     * @return boolean
     */
    isAnswerBasedInputType() {
        return ['multiselect', 'radio', 'select'].indexOf(this.getSelectedInputTypeName()) !== -1;
    }
    /**
     * Return whether the question type can have more than one default answer.
     *
     * @param inputType string
     * @return boolean
     */
    inputTypeAllowsMultipleDefaults(inputType) {
        return ['multiselect'].indexOf(inputType) !== -1;
    }
    /**
     * Keep answer display orders gap-free and aligned with current array order.
     *
     * @param answers Array<any>
     * @return Array<any>
     */
    normalizeAnswerOrder(answers) {
        return (answers || []).map((answer, index) => {
            if (typeof answer.displayOrder === 'function') {
                answer.displayOrder(index);
                return answer;
            }
            return {
                ...answer,
                displayOrder: index,
            };
        });
    }
    /**
     * Handle map answer.
     *
     * @param answer any
     * @param index number
     * @return any
     */
    mapAnswer(answer, index) {
        return {
            id: answer && answer.id ? Number(answer.id) : null,
            active: ko.observable(answer && typeof answer.active !== 'undefined' ? !!answer.active : true),
            displayOrder: ko.observable(answer && typeof answer.displayOrder !== 'undefined' ? answer.displayOrder : index),
            answerDisplay: ko.observable(answer && (answer.answerDisplay || answer.display) ? (answer.answerDisplay || answer.display) : ''),
            value: ko.observable(answer && answer.value ? answer.value : ''),
            defaultAnswer: ko.observable(answer && typeof answer.defaultAnswer !== 'undefined' ? !!answer.defaultAnswer : !!(answer && answer.default)),
        };
    }
}
